import { v4 as uuid } from 'uuid'

export const buildAuthState = (state: object = {}) =>
  btoa(
    JSON.stringify({
      id: uuid(),
      registration: 'trial',
      ...state
    })
  )
